export default {
    "name": "UpdateSettingDefaultValue",
    "kind": "HoudiniMutation",
    "hash": "c3418f7cec27e8d2d9644552ac42e5bc209019f62707878a86ab74adf607e54e",

    "raw": `mutation UpdateSettingDefaultValue($input: SettingsDefaultValueUpdate!) {
  updateSettingDefaultValue(input: $input)
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateSettingDefaultValue": {
                "type": "Boolean",
                "keyRaw": "updateSettingDefaultValue(input: $input)",
                "nullable": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "SettingsDefaultValueUpdate"
        },

        "types": {
            "SettingDefaultShape": {
                "defaultValue": "String",
                "settingId": "UInt"
            },

            "SettingsDefaultValueUpdate": {
                "settings": "SettingDefaultShape"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=3dc7092b25bd09f5218fd4bd19d1d23af4d57e492fec7e278fc2c2acbe1e6740";